<div class="db-first-time-highlight-wrap" #highlight [ngStyle]="elementStyle" *ngIf="hasTooltip">
  <i class="db-icon db-icon-ds-close-bg" (click)="nextStep()" *ngIf="hasCloseBtn"></i>
  <div class="db-first-time-highlight db-first-time-highlight-{{size}}" [ngClass]="{'with-shadow': withShadow}" >
    <ng-container *ngIf="template" [ngTemplateOutlet]="template"></ng-container>
    <div *ngIf="!template" [innerHTML]="content | safeHtml"></div>
    <div class="text-right">
      <button class="ds-btn ds-btn-small" (click)="nextStep(true)" *ngIf="showBtn">
        <span *ngIf="!loading">{{buttonText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </button>
    </div>
  </div>
</div>
<div class="db-first-time-highlight__copy-parent" id="db-first-time-highlight__copy-parent"></div>
<div class="db-cover-content" (click)="nextStep()"></div>
